import { render } from "./Staffs.vue?vue&type=template&id=3d7929d7&scoped=true"
import script from "./Staffs.vue?vue&type=script&lang=js"
export * from "./Staffs.vue?vue&type=script&lang=js"

import "./Staffs.vue?vue&type=style&index=0&id=3d7929d7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d7929d7"]])

export default __exports__